import { useSelector } from 'react-redux';
import { getMediaQueryBreakpoints } from 'ha/modules/UI/selectors';
import useCSSMediaQuery from '@mui/material/useMediaQuery';

export interface MediaQueryBreakpoints {
  xs: boolean;
  sm: boolean;
  md: boolean;
  lg: boolean;
  xl: boolean;
}

export function useMediaQuery(): MediaQueryBreakpoints {
  return useSelector(getMediaQueryBreakpoints);
}

export function useOrientation(): 'portrait' | 'landscape' {
  const isPortrait = useCSSMediaQuery('(orientation: portrait)');

  return isPortrait ? 'portrait' : 'landscape';
}
